const PAYMENT_ORGANIZATION_TYPES = ['PAY', 'INS'];
export const PAYMENT_ORGANIZATION_TYPES_PARAM = PAYMENT_ORGANIZATION_TYPES.join(',');
